{
  "dss": {
    "button": {
      "back": "Mbrapa",
      "cancel": "Anulo",
      "close": "Mbyll",
      "confirmDelete": "Po, fshi",
      "continue": "Vazhdo",
      "logout": "Dil",
      "passwordReset": "Rivendosja e fjalëkalimit",
      "save": "Ruaj",
      "verify": "Verifiko"
    },
    "error": {
      "403": "Nuk keni akses në këtë faqe.",
      "404": "Kjo faqe nuk ekziston.",
      "generic": "Ndodhi një gabim. Ju lutemi provoni përsëri më vonë.",
      "throttling": "Shumë përpjekje. Ky veprim është i bllokuar përkohësisht.",
      "title": "Gabim",
      "title403": "Qasja e refuzuar",
      "title404": "Nuk u gjet"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Politika e privatësisë",
      "terms": "Kushtet dhe afatet"
    },
    "label": {
      "CRMAccountNumber": "Numri i llogarisë CRM",
      "contact": "Kontakt",
      "email": "Email",
      "faq": "FAQ",
      "female": "Znj.",
      "firstname": "Emri",
      "help": "Ndihmë",
      "language": "Gjuha",
      "lastname": "Mbiemri",
      "male": "Z.",
      "needHelp": "Keni nevojë për ndihmë?",
      "newPassword": "Fjalëkalim i ri",
      "newPassword2": "Konfirmo fjalëkalimin e ri",
      "oldPassword": "Fjalëkalimi aktual",
      "organization": "Organizata",
      "password": "Fjalëkalimi",
      "required": "e detyrueshme",
      "salutation": "Përshëndetje",
      "select": "Ju lutem zgjidhni"
    },
    "lang": {
      "de": "Gjermanisht"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Konfirmoni regjistrimin",
        "wait": "Ju lutemi prisni derisa të përfundojë konfirmimi i llogarisë."
      },
      "otp": {
        "btnResend": "Ridërgo kodin e verifikimit",
        "msg": {
          "invalidOTP": "Fjalëkalimi njëpërdorimësh i futur është i pavlefshëm.",
          "resendFail": "Dështoi ridërgimi i kodit. Ju lutemi provoni më vonë."
        },
        "spamDetail": "Kontrolloni kutinë hyrëse dhe dosjen e spamit për një email nga STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Nuk morët email?",
        "subtitle": "Për të vazhduar, duhet të verifikoni adresën tuaj të emailit.",
        "title": "Verifikoni llogarinë tuaj",
        "txtVerifyMail": "Ju lutemi futni kodin e ri të verifikimit që dërguam në adresën tuaj të emailit {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nuk ka asgjë për të përditësuar.",
          "updateError": "Dështoi përditësimi i të dhënave personale.",
          "updated": "Të dhënat personale u përditësuan.",
          "userLoadErr": "Gabim gjatë ngarkimit të të dhënave të përdoruesit. Ju lutemi provoni më vonë."
        },
        "secOrganization": "Organizata",
        "secPersonal": "Personale",
        "secSettings": "Cilësimet e preferuara",
        "title": "Informacione personale"
      },
      "postPwSet": {
        "info": "Tani mund të përdorni fjalëkalimin tuaj të ri.",
        "link_name": "Vazhdo në Self-Service",
        "link_url": "/user/ui/",
        "title": "Fjalëkalimi juaj është ndryshuar"
      },
      "resetPW": {
        "title": "Rivendosni fjalëkalimin tuaj"
      },
      "security": {
        "2fa": {
          "availableMethods": "Metodat e disponueshme 2FA:",
          "info": "Autentifikimi me dy faktorë (2FA) është një veçori sigurie që shton një shtresë shtesë mbrojtjeje në llogarinë tuaj. Kërkon përdorimin e dy metodave për t'u identifikuar, në vend të vetëm emrit të përdoruesit dhe fjalëkalimit.",
          "method": {
            "email": "Email",
            "emailDesc": "Merrni kode njëpërdorimëshe me email për të përfunduar kërkesat e autentifikimit.",
            "oath": {
              "add": {
                "button": "Regjistro aplikacionin Authenticator"
              }
            }
          }
        },
        "authenticator": "Aplikacioni Authenticator",
        "infoFederatedAccount": "Ky llogari menaxhohet nga ofruesi i identitetit të organizatës suaj, kështu që fjalëkalimi nuk mund të ndryshohet këtu. Për të ndryshuar fjalëkalimin, identifikohuni përmes faqes së hyrjes të organizatës suaj ose kontaktoni administratorin tuaj të IT-së.",
        "lastUse": "Përdorur për herë të fundit: {0}.",
        "msg": {
          "invalidPassword": "Fjalëkalimi aktual i dhënë është i pavlefshëm.",
          "passwordAlreadyUsed": "Nuk mund të ripërdoren 5 fjalëkalimet e fundit.",
          "pwUpdateError": "Ndodhi një gabim gjatë ndryshimit të fjalëkalimit.",
          "pwUpdated": "Fjalëkalimi u ndryshua."
        },
        "noDevice": "E pakonfiguruar",
        "oathAdd": {
          "appInfo": "Për ta bërë më të lehtë procesin e hyrjes në STIHL, mund të përdorni aplikacione Authenticator si {0}, {1}, {2} etj. për të gjeneruar fjalëkalime njëpërdorimëshe që përdoren si faktor i dytë gjatë hyrjes.<br/>Nëse keni humbur ose harruar pajisjen tuaj celulare, mund të përdorni në çdo kohë kodin 2FA të dërguar me email.<br/><br/>Ju lutemi ndiqni udhëzimet më poshtë për të konfiguruar pajisjen tuaj të autentifikimit.",
          "badCode": "Kod i pavlefshëm, ju lutemi provoni përsëri.",
          "error": "Ndodhi një gabim gjatë regjistrimit të pajisjes së autentifikimit.",
          "headScan": "1. Skanoni kodin QR me aplikacionin tuaj Authenticator",
          "headVerify": "2. Verifikoni kodin",
          "infoKey": "çelës konfigurimi",
          "infoKeyTitle": "Sekreti juaj me dy faktorë",
          "infoScanBottom": "Nuk mund të skanoni? Mund të përdorni {0} për të konfiguruar manualisht aplikacionin Authenticator.",
          "infoVerify": "Futni kodin e gjeneruar nga aplikacioni juaj Authenticator.",
          "success": "Pajisja juaj e autentifikimit është regjistruar. Tani mund ta përdorni për t'u identifikuar.",
          "title": "Regjistroni pajisjen tuaj të autentifikimit me dy faktorë"
        },
        "oathDelete": {
          "error": "Ndodhi një gabim gjatë fshirjes së pajisjes së autentifikimit.",
          "success": "Pajisja e autentifikimit u fshi."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey janë çifte çelësash kriptografikë (një çelës publik dhe një çelës privat) që ruhen nga një autentifikues që kontrolloni ju. Autentifikuesi mund të provojë se përdoruesi është i pranishëm dhe i autorizuar për të përdorur passkey-n. Autentifikuesit vërtetojnë autorizimin me një PIN, kod, biometrik ose fjalëkalim pajisjeje, në varësi të aftësive dhe konfigurimit të tyre. Autentifikuesit kanë forma të ndryshme: një pajisje iPhone ose Android, Windows Hello, një çelës sigurie harduerik FIDO2 ose një menaxher fjalëkalimesh.",
            "info2": "Kur identifikoheni në STIHL duke përdorur një passkey, autentifikuesi juaj përdor kriptografinë e çelësit publik për të provuar identitetin tuaj te STIHL pa e dërguar kurrë vetë passkey-n. Passkey-t lidhen me një domen të faqes në internet, si stihl-sso.com, dhe kërkojnë një lidhje të sigurt, që do të thotë se shfletuesi do të refuzojë të autentikohet në një faqe të ngjashme phishing. Këto veti i bëjnë passkey-t shumë rezistentë ndaj phishing dhe shumë më të vështirë për t'u sulmuar sesa SMS ose TOTP 2FA.",
            "info3": "Shërbimet e passkey me mbështetje në cloud lejojnë sinkronizimin e passkey-ve midis pajisjeve (si pajisje Apple, pajisje Android ose menaxherë fjalëkalimesh), në mënyrë që ato të mund të përdoren në më shumë vende dhe të humbasin më rrallë. Pasi të keni vendosur një passkey të sinkronizuar në një pajisje, ai është i disponueshëm në disa pajisje që përdorin të njëjtin shërbim. Për shembull, nëse regjistroni një passkey me llogarinë tuaj iCloud duke përdorur Touch ID të MacBook-ut tuaj, atëherë mund të përdorni atë passkey me fytyrë, gjurmë gishtash, PIN ose fjalëkalim pajisjeje në mënyrë të ndërrueshme në disa pajisje të lidhura me të njëjtën llogari iCloud.",
            "title": "Rreth Passkeys"
          },
          "add": {
            "button": "Shto Passkey të ri",
            "error": "Ndodhi një gabim gjatë shtimit të passkey-t të ri.",
            "success": "U shtua një passkey i ri."
          },
          "delete": {
            "button": "Fshi Passkey",
            "error": "Ndodhi një gabim gjatë fshirjes së këtij passkey.",
            "success": "Passkey u fshi."
          },
          "edit": {
            "error": "Ndodhi një gabim gjatë ruajtjes së emrit të passkey-t.",
            "name": "Emri i Passkey",
            "success": "Emri i passkey-t u përditësua.",
            "title": "Jepini emër Passkey-t tuaj për ta dalluar nga të tjerët"
          },
          "info": "Passkey është një alternativë e thjeshtë dhe e sigurt ndaj fjalëkalimeve, që verifikon identitetin tuaj duke përdorur prekje, njohje fytyre, fjalëkalim pajisjeje ose PIN.",
          "none": "Asnjë Passkey i konfiguruar.",
          "reallyDelete": "Jeni të sigurt që dëshironi të fshini Passkey?",
          "registeredPasskeys": "Passkeys tuaj të regjistruar:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Jeni të sigurt që dëshironi të fshini pajisjen e autentifikimit?",
        "secMFA": "Autentifikimi me dy faktorë",
        "secPwdChange": "Ndrysho fjalëkalimin",
        "title": "Siguria"
      },
      "setPW": {
        "acceptTC": "Ju lutemi konfirmoni {terms} tona dhe lexoni {privacy} tonë.",
        "killSSO": "Anulo të gjitha sesionet aktive",
        "msg": {
          "tokenExpired": "Lidhja ose kodi i fjalëkalimit ka skaduar. Ju lutemi ndiqni lidhjen për të rivendosur fjalëkalimin: {link}."
        },
        "privacy": "Politika e privatësisë së të dhënave",
        "terms": "Kushtet dhe afatet",
        "title": "Shkruani fjalëkalim të ri"
      }
    },
    "validations": {
      "hasDigit": "Duhet të përmbajë shifra",
      "hasLowercase": "Duhet të përmbajë shkronja të vogla",
      "hasSpecial": "Duhet të përmbajë karaktere speciale: {chars}",
      "hasUppercase": "Duhet të përmbajë shkronja të mëdha",
      "invalidCharacters": "Përmban karaktere të pavlefshme",
      "maxLength": "Maksimumi {max} karaktere të lejuara",
      "minLength": "Minimumi {min} karaktere të kërkuara",
      "notSameAsEmail": "Shumë i ngjashëm me adresën e emailit",
      "onlyValidCharactersAllowed": "Lejohen vetëm shkronja, numra dhe hapësira.",
      "required": "Fushë e detyrueshme",
      "sameAsPassword": "Fjalëkalimet nuk përputhen",
      "tcAccepted": "Ju lutemi konfirmoni kushtet dhe afatet tona.",
      "validEmail": "Adresë emaili e pavlefshme.",
      "validOTP": "Ju lutemi shkruani kodin e verifikimit."
    }
  }
}
